import { render, staticRenderFns } from "./box7.vue?vue&type=template&id=4aa1a3d8&scoped=true&"
import script from "./box7.vue?vue&type=script&lang=js&"
export * from "./box7.vue?vue&type=script&lang=js&"
import style0 from "./box7.vue?vue&type=style&index=0&id=4aa1a3d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa1a3d8",
  null
  
)

export default component.exports